<nav aria-label="breadcrumb" style="padding-top: 10px;">
    <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="javascript:void(0)" routerLink="/" title="">{{'Dashboard' | translate}}</a></li>
        <li class="breadcrumb-item active">{{'Profile' | translate}}</li>
    </ol>
</nav>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card p-4">
                <div class="col-md-12">
                    <h4>{{'Profile' | translate}}</h4>
                </div>
                <div class="card-body">
                    <form novalidate="">
                        <div class="custom-form ">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <div class="divformlabel">
                                            <label for="username">{{'Username' | translate}}</label>
                                        </div>
                                        <input readonly placeholder="{{'Username' | translate}}" type="text" [(ngModel)]="userName" [ngModelOptions]="{standalone: true}" class="form-control" name="userName" id="userName">
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <div class="divformlabel">
                                            <label for="fullname">{{'FullName' | translate}}</label>
                                        </div>
                                        <input readonly placeholder="{{'FullName' | translate}}" [(ngModel)]="displayName" [ngModelOptions]="{standalone: true}" class="form-control" name="displayName" id="fullname" type="text">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="form-group">
                                        <div class="divformlabel">
                                            <label for="email">{{'Email' | translate}}</label>
                                        </div>
                                        <input readonly placeholder="{{'Email' | translate}}" id="email" type="email" [ngModelOptions]="{standalone: true}" [(ngModel)]="email" class="form-control" name="email">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="form-group">
                                        <div class="divformlabel">
                                            <label for="mobile">{{'MobileNumber' | translate}} </label>
                                        </div>
                                        <input id="mobile" maxlength="14" (keypress)="numberOnly($event)" placeholder="{{'MobileNumber' | translate}}" type="text" [(ngModel)]="mobile" [ngModelOptions]="{standalone: true}" class="form-control" name="mobile" [ngModelOptions]="{standalone: true}">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="form-group">
                                        <div class="divformlabel">
                                            <label for="telephoneNo">{{'TelephoneNumber' | translate}}</label>
                                        </div>
                                        <input id="telephoneNo" placeholder="{{'TelephoneNumber' | translate}}" [ngModelOptions]="{standalone: true}" [(ngModel)]="telephoneNo" class="form-control" name="telephoneNo" type="tele">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 mt-3">
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox" style="display: flex;align-items: center;">
                                            <input [(ngModel)]="isActive" [ngModelOptions]="{standalone: true}" id="isActive" name="isActive" type="checkbox">
                                            <label for="isActive" style="margin-top: 4px;">
                                                <span>{{'Active' | translate}}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-3">
                                <p class="text-right">
                                    <button [disabled]="!telephoneNo  || !mobile" (click)="onEdit()" class="btn btn-primary mt-3" style="width: 100%;" type="button">{{'Edit' | translate}}</button>
                                </p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            {{'UploadaSignature' | translate}}
                            <img style="width:200px;max-height:50px;" src="{{signatureSrc}}" />
                            <ng-container>
                                <button (click)="file1.click();" class="btn btn-secondary mt-2"><i class="fa fa-upload"></i> {{'ChooseaPhoto' | translate}}</button>
                            </ng-container>
                            <input style="display:none;" type="file" (change)="signatureSelected($event)" accept="image/*" #file1>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4">
                            <p>{{'ManualSignature' | translate}}</p>
                            <canvas style="background-color:#fff;  height:50px;width:200px; border:1px solid #000;" id='canvasSignature' #canvas></canvas>
                            <br />
                            <button (click)=" savesign();" class="btn btn-secondary mt-2">{{'Save' | translate}}</button>
                            <button (click)="  clearsrow();" class="btn btn-secondary mt-2">{{'Delete' | translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>